import {
  ColorClass,
  DropDownButton,
  DropDownButtonDirection,
  Icon,
  IconIdentifier,
  Input,
  Placement,
  Tooltip,
} from '@aus-platform/design-system';
import { isEmpty } from 'lodash';
import type { HeapClusterTableHeaderProps } from './types';

export const HeapClusterTableHeader: React.FC<HeapClusterTableHeaderProps> = ({
  setIsTableExpanded,
  isTableExpanded,
  handleCloseTable,
  heapClustersOptions,
  setActiveHeapCluster,
  activeHeapCluster,
  openDeleteHeapModal,
  selectedHeaps,
  handleDownloadSelectedHeaps,
  handleDownloadAllHeaps,
}) => {
  // Handlers.
  const handleTableExpand = () => {
    setIsTableExpanded(!isTableExpanded);
  };

  const onChangeActiveHeapCluster = (selectedOption) => {
    setActiveHeapCluster({
      clusterId: selectedOption.value,
      clusterName: selectedOption.label,
    });
  };

  return (
    <div className="heap-cluster-table__header">
      <div className="heap-cluster-table__header__container">
        <div className="heap-cluster-table__header__title">
          Active Heap Cluster
        </div>
        <Input.Select
          options={heapClustersOptions}
          maxMenuHeight={187}
          onChange={onChangeActiveHeapCluster}
          value={{
            value: activeHeapCluster?.clusterId,
            label: activeHeapCluster?.clusterName,
          }}
        />
      </div>
      <div className="heap-cluster-table__header__container">
        <Tooltip hoverText="Delete" placement={Placement.Top}>
          <Icon
            identifier={IconIdentifier.Bin}
            size={24}
            colorClass={ColorClass.AccentError}
            onClick={openDeleteHeapModal}
          />
        </Tooltip>

        <Tooltip hoverText="Download" placement={Placement.Top}>
          <DropDownButton
            rightIconIdentifier={IconIdentifier.Download}
            drop={DropDownButtonDirection.Down}
            className="heap-cluster-table__header__dropdown-menu"
          >
            <DropDownButton.Item
              onClick={handleDownloadSelectedHeaps}
              disabled={!!isEmpty(selectedHeaps)}
            >
              Download Selected Heaps
            </DropDownButton.Item>
            <DropDownButton.Item onClick={handleDownloadAllHeaps}>
              Download All Heaps
            </DropDownButton.Item>
          </DropDownButton>{' '}
        </Tooltip>

        <Tooltip
          hoverText={isTableExpanded ? 'Collapse View' : 'Expand View'}
          placement={Placement.Top}
        >
          <Icon
            identifier={
              isTableExpanded ? IconIdentifier.Collapse : IconIdentifier.Expand
            }
            size={24}
            colorClass={ColorClass.Neutral300}
            onClick={handleTableExpand}
          />
        </Tooltip>

        <Tooltip hoverText="Close" placement={Placement.Top}>
          <Icon
            identifier={IconIdentifier.CrossSmall}
            size={24}
            colorClass={ColorClass.Neutral300}
            onClick={handleCloseTable}
          />
        </Tooltip>
      </div>
    </div>
  );
};
